import axiosInstance from './axiosConfig';

export const storageApi = {
  overview: () => axiosInstance.get('/api/storage/overview').then((r) => r.data),
  scan: (payload = {}) => axiosInstance.post('/api/storage/scan', payload).then((r) => r.data),
  duplicates: (params = {}) =>
    axiosInstance.get('/api/storage/duplicates', { params }).then((r) => r.data),
  attachments: (params = {}) =>
    axiosInstance.get('/api/storage/attachments', { params }).then((r) => r.data),
  duplicateAttachments: () =>
    axiosInstance.get('/api/storage/duplicate-attachments').then((r) => r.data),
  newsletters: (params = {}) =>
    axiosInstance.get('/api/storage/newsletters', { params }).then((r) => r.data),
  oldMails: (params = {}) =>
    axiosInstance.get('/api/storage/old-mails', { params }).then((r) => r.data),
  trash: () => axiosInstance.get('/api/storage/trash').then((r) => r.data),
  spam: () => axiosInstance.get('/api/storage/spam').then((r) => r.data),
  unusedLabels: () => axiosInstance.get('/api/storage/unused-labels').then((r) => r.data),
  emptyFolders: () => axiosInstance.get('/api/storage/empty-folders').then((r) => r.data),
  reports: () => axiosInstance.get('/api/storage/reports').then((r) => r.data),
  cleanup: (payload) => axiosInstance.post('/api/storage/cleanup', payload).then((r) => r.data),
  getSettings: () => axiosInstance.get('/api/storage/settings').then((r) => r.data),
  updateSettings: (payload) =>
    axiosInstance.put('/api/storage/settings', payload).then((r) => r.data),
  listRules: () => axiosInstance.get('/api/storage/rules').then((r) => r.data),
  saveRule: (payload) => axiosInstance.post('/api/storage/rules', payload).then((r) => r.data),
  deleteRule: (id) => axiosInstance.delete(`/api/storage/rules/${id}`).then((r) => r.data),
};

export default storageApi;
